import Service from "../../AuthService";
const ExportSheet = {
    getExportSheet(page) {
        return Service.get("/sheet-export?page="+page);
    },
    showExportSheet(id) {
        return Service.get("/sheet-export/" + id);
    },
    updateExportSheet(id, data) {
        return Service.put("/sheet-export/" + id, data);
    },
    createExportSheet(data) {
        return Service.post("/sheet-export", data);
    },
    deleteExportSheet(id) {
        return Service.delete("/sheet-export/" + id);
    },
    searchExportSheet(page,code, date) {
        return Service.post(
            "/search-sheet-export?page="+page+"&code=" + code + "&date=" + date
        );
    }
};
export default ExportSheet;
